import { gql } from '@efficiently/client-core-graphql-models';

export const UPDATE_FINISHES = gql(`
	mutation FinishDomainUpdateFinishes($finishes: [FinishInput!]!) {
		updateFinishes(finishes: $finishes) {
			_id
		}
	}
`);
